import { call, put, takeEvery, select } from 'redux-saga/effects'

import api from '~/services/api'
import {
	listQuestion,
	listQuestionSuccess,
	listQuestionFailure,
	setLoadingAI,
	updateFieldsWithAIResponse,
} from '.'
import { setResetAnswer } from '../answer'

export default function* rootSaga() {
	yield takeEvery(listQuestion, listQuestionSaga)
}

function* listQuestionSaga({ payload = {} }) {
	const { modelId, documentTitle, parent, isExternal = false } = payload

	try {
		let data = null

		if (isExternal) {
			data = select((state) => state.externalContract.data.Template)
		} else {
			const response = yield call(api.get, `/templates/${modelId}`)
			data = response.data
		}

		yield put(setResetAnswer())
		yield put(listQuestionSuccess({ modelId, documentTitle, parent, data }))

		const contextAi = yield select((state) => state.question.contextAi)
		const context_path = yield select((state) => state.contextAi.Context)

		const prompts = data.form.flatMap((page) =>
			page.fields
				.filter((field) => field.prompt && field.prompt.trim() !== '')
				.map((field) => field.prompt)
		)

		if (contextAi && prompts.length > 0) {
			yield put(setLoadingAI(true))

			const response = yield call(api.post, '/prompts-ai/', {
				prompts: prompts,
				context_file_path: context_path,
			})
			if (response.status === 200) {
				yield put(updateFieldsWithAIResponse({ responses: response.data }))
			}
		}
		yield put(setLoadingAI(false))
	} catch (error) {
		yield put(listQuestionFailure(error))
	}
}
